/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Archived task feedback for a graded exam on the grade report.
 */
export interface GradedAttemptTaskFeedback {
  title?: string;
  feedback?: string;
}
